import { MutationFunction, MutationKey, MutationOptions } from '@tanstack/query-core';
import { parseMutationArgs, useMutation as useReactMutation, UseMutationResult } from '@tanstack/react-query';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

const useMutation = <T = void, TError = RequestExceptionWithResponse, TVariables = void, TContext = unknown>(
    arg1: MutationKey | MutationFunction<T, TVariables> | MutationOptions<T, TError, TVariables, TContext>,
    arg2?: MutationFunction<T, TVariables> | MutationOptions<T, TError, TVariables, TContext>,
    arg3?: MutationOptions<T, TError, TVariables, TContext>,
): UseMutationResult<T, TError, TVariables, TContext> => {
    const options = parseMutationArgs<MutationOptions<T, TError, TVariables, TContext>>(arg1, arg2, arg3);
    return useReactMutation<T, TError, TVariables, TContext>(options);
};

export default useMutation;
